const options = {
  can_do: 'integer',
  can_review: 'integer',
  instant_key: 'integer',
  question_sequence: 'integer',
  only_show_finish_button_when_reach_last_question: 'integer',
  retake_requires_admin_acceptance: 'integer',
  disable_intro_sticky_audio_control: 'integer',
  instant_marking_on_finish: 'integer',
  score_best_or_last_exam_order: 'string',
  disable_question_audio_replay: 'integer',
  is_toeic_test: 'integer',
  regulation: 'string',
  can_fix_wrong_questions: 'integer',
  fullscreen_layout: 'integer',
  hide_controls: 'integer',
};
const attachmentProperties = {
  id: 'string',
  path: 'string',
  name: 'string',
  ext: 'string',
  dir: 'string',
  root: 'string',
  link: 'string',
  hostname: 'string',
  host: 'string',
  imgOptLocal: 'string',
  desc: 'string',
  dt: 'string',
  dti: 'string',
  et: 'string',
  st: 'string',
};

export const metadataSchema = {
  type: 'array',
  required: false,
  items: {
    type: 'object',
    required: false,
    properties: {
      id: {
        type: 'string',
        required: true,
      },
      iid: {
        type: 'string',
        required: true,
      },
      ntype: {
        type: 'string',
        required: true,
      },
      pid: {
        // client side pid
        type: 'string',
      },
      // avatar: {
      //   type: 'string',
      // },
      duration: {
        type: 'string',
        required: false,
      },
      weighted: {
        type: 'number',
        minimum: 0,
        maximum: 100,
      },
      require: {
        type: 'number',
        minimum: 0,
        maximum: 1,
      },
      options,
      group: 'integer',
      average_of_children_score: 'integer',
      great_exercise_score: 'integer',
      hours: 'integer',
      name: {
        type: 'string',
        required: true,
      },
      sequential: 'array',
      intro_sticky: 'integer',
      intro_sticky_position: 'string',
      start_time: 'integer',
      end_time: 'integer',
      speaker: {
        name: 'string',
        avatar: 'string',
      },
      type: 'string',
      sub_type: 'string',
      faculty: 'string',
      ico: 'string',
      score: 'integer',
      survey_applied_item_relation_id: 'string',
      scorm_file: 'object',
      processing_scorm: 'any',
      scorm_directory_url: 'string',
      exam_template_iid: 'integer',
    },
  },
};

const user = {
  id: 'string',
  iid: 'string',
  name: 'string',
  avatar: 'string',
  phone: 'string',
  mail: 'string',
  lname: 'string',
};

const matchingPair = {
  type: 'array',
  items: {
    type: 'object',
    properties: {
      id: 'string',
      content: 'string',
      avatar: 'string',
    },
    required: false,
  },
};

const socialVideo = {
  type: 'object',
  properties: {
    id: 'string',
    st: 'string',
    et: 'string',
    dt: 'string',
  },
};

const audio = {
  type: 'object',
  properties: {
    root: 'string',
    dir: 'string',
    path: 'string',
    name: 'string',
    id: 'string',
  },
};

const penalty = {
  type: 'object',
  required: false,
  properties: {
    wrong_count: 'integer',
    substract_amount: 'float',
    unit: 'string',
    fail: 'integer',
  },
};

export const treeNodeSchema = {
  title: 'Example Schema',
  type: 'object',
  properties: {
    is_virtual: 'integer', // room or building (venue) is virtual or not
    credit: 'integer',
    type: {
      type: 'integer',
      minimum: 0,
    },
    help_text: {
      type: 'string',
    },
    mc_answers: 'array',
    answers2: 'array',
    answer_as_hint: 'object',
    reorders: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          id: 'string',
          content: 'string',
          avatar: 'string',
        },
        required: false,
      },
    },
    l_pair: matchingPair,
    r_pair: matchingPair,
    wordmax: 'integer',
    wordmin: 'integer',
    tpl_type: 'string', // syllabus use this
    sub_type: 'string',
    pass_score: 'integer',
    allow_passing_by_teacher: 'integer',
    applicable_scope: 'string',
    is_root_rubric: 'integer',
    rubric_iid: 'integer',
    speaking_type: 'string',
    weighted: {
      type: 'number',
      minimum: 0,
      maximum: 100,
    },
    passing_scheme: 'string',
    passing_scheme_data: {},
    sequential_learning_type: 'string',
    weight_scheme: 'string',
    question_display_template: 'string',
    max_number_of_questions_per_try: 'integer',
    iid: 'string',
    id: 'string',
    ntype: 'string',
    avatar: 'string',
    address: 'string',
    position: 'string',
    ad_username: 'string',
    name: 'string',
    phonetic: 'string',
    eng_name: 'string',
    tax_identification_number: 'string',
    managing_units: 'string',
    remind_finish_course_setting: 'string',
    birthday: 'integer',
    group: 'integer', // group of question
    code: 'string',
    admission_code: 'string',
    departments: 'array',
    slug: 'string',
    title: 'string',
    content: 'string',
    duration: 'string',
    aggregated_duration: 'string',
    learn_duration: 'string',
    break_time: 'string',
    is_close: 'bool',
    is_public: 'integer',
    is_active: 'bool',
    require_otp: 'integer', // contest
    ongoing_status: 'string',
    feedback_true: 'string',
    feedback_false: 'string',
    youtube: socialVideo,
    vimeo: socialVideo,
    audio: 'array',
    player: 'string', // vocab use this
    overview: 'string',
    vid: 'string',
    exercise_number: 'string',
    nr_of_exam_questions: 'integer', //exam template
    total_exam_score: 'integer', // total exam score...
    passing_score: 'integer', // score considered
    bank_questions_count: 'integer',
    bank_practice_courses: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          id: 'string',
          iid: 'integer',
          syllabus: 'integer',
          type: 'string',
        },
      },
    },

    // exercise
    exercise_templates: 'array',

    question_banks: 'array',
    question_banks_detail: 'array',

    total_of_question: 'integer',
    difficulties: 'string',
    svid: 'string',
    vimeo_vid: 'string',
    vimeo_svid: 'string',
    attachments: {
      type: 'array',
      items: {
        type: 'object',
        properties: attachmentProperties,
      },
    },
    download_materials: {
      type: 'array',
      items: {
        type: 'object',
        properties: attachmentProperties,
      },
    },
    st: 'string',
    et: 'string',
    // tracking_line: 'array',
    vcs_skills: {
      type: 'object',
      properties: {
        speak: 'integer',
        advanced: 'integer',
        basic: 'integer',
        complete: 'integer',
      },
    },
    answers: 'array',
    correctAnswer: 'any',
    sw: 'float',
    template: 'object',
    questionType: 'string',
    inlineText: 'string',
    isVocabQuestion: 'boolean',
    correctPosition: 'integer',
    yt_vid: 'string',
    description: 'string',
    detailed_description: 'string',
    teaching_hours: 'integer',
    specialize_hours: 'integer',
    is_full_time_teacher: 'integer',
    is_simple_contract: 'integer',
    value: 'string',
    mail: 'string',
    phone: 'string',
    syllabus: 'integer',
    max_depth: 'integer',
    private: 'integer',
    school: 'string',
    vid_gb: 'string', // vocab gb vid
    vid_us: 'string', // vocab
    skill: 'string',
    accept_files: 'string',
    examples: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          name: 'string',
          vname: 'string',
        },
      },
    },
    tags: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    import_tags: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    pid: 'string',
    status: 'string',
    ts: 'integer',
    tracking_line: {
      type: 'array',
      items: {
        type: 'integer',
      },
    },
    staff: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          ...user,
          roles: {
            type: 'array',
            items: {
              type: 'string',
            },
          },
        },
        required: false,
      },
    },
    employee: {
      type: 'object',
      properties: {
        iid: 'integer',
        id: 'string',
        name: 'string',
        avatar: 'string',
      },
      required: false,
    },
    u: {
      type: 'object',
      properties: user,
      required: false,
    },
    children: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    metadata: metadataSchema,
    learning_items: metadataSchema,
    practice_items: metadataSchema,
    entry_items: metadataSchema,
    output_items: metadataSchema,
    apply_items: metadataSchema,
    refresh_items: metadataSchema,
    exam_template_iid: 'integer',
    aspects_percent: {
      // type: 'array',
      // required: false,
      // items: {
      type: 'object',
      properties: {
        learning: 'float',
        practice: 'float',
        output: 'float',
        apply: 'float',
        pass_score: 'float',
      },
      // },
    },
    effort_sources: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    penalty_practice: 'integer', // penalty,
    // penalty_apply: penalty,
    expiry: {
      // type: 'array',
      // required: false,
      // items: {
      type: 'object',
      properties: {
        valid_duration: 'float',
        valid_unit: 'string',
        substract_amount: 'float',
        score_unit: 'string',
        time_unit: 'string',
      },
      // },
    },
    skills: 'any', //To fix bug populate data for skills of exam template
    passdef: 'string',
    can_review: 'integer',
    can_redo: 'integer',
    paper_number: 'integer',
    hours: 'integer',
    ...options,
    freeze: 'integer',
    editable: 'boolean',
    has_exam_shift: 'boolean',
    publish_level: 'string',
    ip_ranges: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    academic_rank: 'string',
    academic_degree: 'string',
    is_teaching_out_of_hours: 'integer',
    scan_avatar: 'string',
    sex: 'integer',
    nationality: 'string',
    ethnicity: 'string',
    identification_card: 'string',
    task_list: 'object',
    settings__language: 'string',
    parent: 'object',
    parents: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          id: 'string',
          relationship_of_parent: 'string',
          name: 'string',
          iid: 'integer',
        },
      },
    },
    parent__name: 'string',
    parent__phone: 'string',
    payer: 'object',
    payer__name: 'string',
    payer__phone: 'string',
    department: 'string',
    training: 'string',
    org_province_id: 'string',
    org_district_id: 'string',
    school__province: 'string',
    school__district: 'string',
    school__id: 'string',
    scholarship: 'string',
    facebook_address: 'string',
    has_enough_records_or_not: 'integer',
    admission_documents: 'array',
    english_score_12: 'float',
    average_score_12: 'float',
    note: 'float',
    scan_attach_files: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          id: 'string',
          path: 'string',
          name: 'string',
          ext: 'string',
          dir: 'string',
          root: 'string',
          link: 'string',
          hostname: 'string',
          host: 'string',
          imgOptLocal: 'string',
        },
      },
    },
    conversion_rate: 'integer',
    name_mobile: 'string',
    short_name: 'string',
    content_mobile: 'string',
    bg_color: 'string',
    avatar_disabled: 'string',
    slogan: 'string',
    exam_regulation: 'string',
    exam_type: 'string',
    contest_code: 'string',
    exam_round: 'string',
    exam_round_iid: 'integer',
    exam_sub_type: 'string',
    exam_method: 'string',
    can_do: 'integer',
    isMetadata: 'boolean',
    options,
    sequential_learning: 'integer',
    saw_training_package: 'array',
    certificate: 'integer',
    percent_complete: 'integer',
    featured: 'integer',
    price: 'integer',
    province: 'string',
    provinceName: 'string',
    district: 'string',
    districtName: 'string',
    room_seat: 'integer',
    room_size: 'integer',
    room_type: 'string',
    weighed_score: {
      type: 'number',
      minimum: 0,
      maximum: 1,
    },
    prefix_apply: 'array',
    is_clone: 'number',
    clone_from: 'any',
    sequential: 'array',
    rubric: 'array',
    prerequisites: 'array',
    active_status: 'string',
    is_exam: 'number',
    assignment_group: 'any',
    start_time: 'integer',
    end_time: 'integer',
    time: 'integer',
    register_end_time: 'integer',
    edit_end_time: 'integer',
    contest_status: 'string',
    items: 'array',
    sessions: 'array',
    teachers: 'array',
    rooms: 'array',
    room_types: 'array',
    location: 'string',
    class_iids: 'array',
    teacher_iids: 'array',
    room_iids: 'array',
    slots_of_day: {
      type: 'object',
      properties: {
        0: 'string',
        1: 'string',
        2: 'string',
        3: 'string',
        4: 'string',
        5: 'string',
        6: 'string',
      },
    },
    relationship_of_parent: 'string', // father|mother
    children_of_parent: 'array', // danh sách user iid của con
    info_of_children: 'array', // thông tin của con
    is_parent: 'integer', // online|ilt
    learning_type: 'string', // online|ilt
    max_student: 'number',
    start_reg_time: 'number',
    end_reg_time: 'number',
    withdraw_deadline: 'number',
    degree: 'integer',
    semester_count: 'integer',
    scale: 'string',
    scaled_children: 'array',
    start_date: 'integer',
    end_date: 'integer',
    time_from: 'integer',
    timetableConfigs: {
      type: 'object',
      properties: {
        start_time: 'integer',
        end_time: 'integer',
        timeframe: 'integer',
      },
    },
    campus_iids: {
      type: 'array',
      items: {
        type: 'integer',
      },
    },
    campuses: 'array',
    date_to: 'integer',
    allowed_late_duration: 'integer',
    credit_syllabus: 'integer',
    ico: 'integer',
    program: 'integer',
    semester: 'integer',
    icoObject: 'array',
    majorObject: 'array',
    programObject: 'array',
    semesterObject: 'array',
    creditSyllabusObject: 'array',
    histories: 'array',
    attendance: 'array',
    courses: 'array',
    feedback: 'array',
    is_plagiarism: 'integer',
    structure_answer: 'array',
    sp1_layout: 'integer',
    rubric_marking: 'array',
    training_level: 'string',
    training_mode: 'string',
    major: 'integer',
    majors: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          major: 'integer',
          training_mode: 'string',
          training_level: 'string',
          program: 'integer',
          faculty: 'integer',
          ico: 'integer',
        },
      },
    },
    dates: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          date_time: 'integer',
          start_time: 'integer',
          end_time: 'integer',
          session_iid: 'integer',
        },
      },
    },
    level: 'integer',
    grade: 'integer',
    groupObject: 'object',
    course_iid: 'integer',
    organization: 'integer',
    faculty: 'integer',
    degrees: 'array',
    max_truant: 'object',
    data: 'object',
    __expand: 'any',
    phongbans: 'array',
    lname: 'string',
    original_lname: 'string',
    user_organizations: 'array',
    academic_categories: 'array',
    startdate: 'integer',
    student_types: 'array',
    roles: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    is_visible: 'string',
    organization_iid: 'integer',
    score: 'integer',
    positions: 'array',
    assignment_marking_teachers: 'array',
    english_name: 'string',
    practice_credit: 'integer',
    theory_credit: 'integer',
    is_mandatory: 'integer',
    is_revenue: 'integer',
    exam_resit_nth: 'integer',
    smart: 'integer', // whether or not a group is manual | smart
    guest_can_learn_item: 'integer',
    resolve_count: 'integer',
    resolved_count: 'integer',
    allow_feedback: 'integer',
    allow_comment: 'integer',
    last_synced: 'integer',
    advancing_criterion: 'string',
    exam_format: 'string', // TOEIC | toeic_reading | toeic_listening...
    top_contestant: 'integer',
    min_core: 'integer',
    number_contestants: 'integer',
    number_exam_shifts: 'integer',
    number_exam_rounds: 'integer',
    number_exam_stores: 'integer',
    exam_scos_count: 'integer', // number of exam scos (đề gốc) for exam round
    paper_count: 'integer',

    // smart group
    current_members: 'integer', // number of current members in a group
    pending_members: 'integer', // number of pending members in a group
    redundant_members: 'integer', // number of redundant members in a group
    scanning_status: 'integer',
    filtersets: {
      type: 'array',
      items: {
        user_organizations: 'array',
        positions: 'array',
        sex: 'array',
        skill: {
          type: 'object',
          properties: {
            iid: 'integer',
            level: 'integer',
            op: 'string',
            availableFilters: 'array',
          },
        },
      },
    },
    scorm_file: 'object',
    processing_scorm: 'any',
    scorm_directory_url: 'string',
    organizations: 'array',
    organizations_name: 'array',
    accessible_in_sub_organizations: 'int',
    difficulty: 'string',
    shufflable: 'integer',
    acs: 'integer',
    reorder_type: 'string',
    number_question_type: 'string',
    is_credit_transfert_group: 'integer',
    applicable_to_all_subjects: 'integer',
    score_scale_with_prerequisites: 'array',
    exam_template: 'any',
    allow_practice_exam_template: 'integer',
    total_score: 'float',
    point_spectrum: 'any',
    preload_data_time_amount: 'integer',
    no_fullscreen: 'integer', // whether or not examround in contest is played in full screen. Sme contest we don't wanna
    // play in full screen mode

    violation_limit: 'integer',
    allowed_submit_time: 'integer',
    exam_freeze_period: 'integer',
    allowed_edit_exam_shift_time: 'integer',
    // publish_score_start_time: 'integer',
    // publish_score_end_time: 'integer',
    should_show_score: 'integer',
    contestants_can_preview_take: 'integer',
    should_allow_remark: 'integer',
    number_of_advancing_contestants: 'integer',
    min_score: 'float',
    scaled_total_score: 'float',
    score_rounding_digits: 'string',
    score_rounding_algo: 'string',
    equivalent_position: 'any',
    evn_equivalent_position: 'any',
    shareable: 'integer',
    shared_to: 'array',
    group_iid: 'integer',
    giid: 'integer', // K12 group iid for EP
    rubric_type: 'string',
    program_iid: 'integer',
    enrolment_plan_iid: 'integer',
    is_shared_from_ancestor_organizations: 'integer',
    ep_iid: 'integer', // group's ep
    enrolment_plans: 'array',
    optional_enrolment_plans: 'array',
    courses_in_enrolment_plan_credits: 'any',
    number_of_students: 'integer',
    can_only_add_online_only_credit: 'bool',
    attach_result_files: 'array',
    transcript_status: 'string',
    online_only: 'integer',
    abacRoles: 'array',
    approved_history: 'array',
    used_for: 'array',
    freeze_actions: 'integer',
    compulsory_role: 'integer',
    applied_course_type: 'string',
    survey_applied_item_relation_id: 'string',
    stop_inviting_date: 'integer',
    appliedTargetDetail: 'array',
    smart_group_iid: 'integer',
    smart_group: 'object',
    settings: 'object',
    organizations_pushed: 'array',
    detail: 'string',
    weekdays: 'array',
    effect_to_timetable: 'integer',
    room: 'object',
    training_plan_iid: 'integer',
    scheduled: 'object',
    training_plan: {
      type: 'object',
      properties: {
        iid: 'integer',
        name: 'string',
        code: 'string',
      },
    },
    job_position_codes: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    CDANHTDUONG_EVN_ID: 'integer',
    CDANHTDUONG_EVN_CODE: 'string',
    CDANHTDUONG_EVN: 'string',
    top_equivalent_position: 'array',
    top_equivalent_positions: 'array',
    survey_target_type: 'string',
    calculate_rating_automatically: 'int',
    apply_survey_for: 'string',
    external: 'integer',
    contracts: 'array',
    isMultiLevelEquivalent: 'integer',
    display_template: 'string',
    is_any_insert_relation_job_running: 'integer',
    sync_learner_progress_for_report: 'object',
    number_of_courses: 'integer',
    number_of_members: 'integer',
    hrms: 'integer',
    have_certificate: 'integer',

    // bus drivers
    drivers: {
      type: 'array',
      items: {
        name: 'string',
        phone: 'string',
      },
    },

    // school bus locations
    locations: {
      type: 'array',
      items: {
        name: 'string',
        time: 'string',
      },
    },
    // semester is_current
    is_current: 'integer',
    school_year_iid: 'integer',
    school_year: 'object',
    bus: 'integer', // bus iid for the group
    score_scale: 'string',
    venue_iids: {
      type: 'array',
      items: {
        type: 'integer',
      },
    },
    semester_iids: {
      type: 'array',
      items: {
        type: 'integer',
      },
    },
    semesters: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          id: 'string',
          iid: 'integer',
          start_date: 'integer',
          end_date: 'integer',
          name: 'string',
        },
      },
    },
    k12_grades_synced: 'integer', // whether or not users in k12 group have updated their grade & grade name & group
    group_iids: {
      type: 'array',
      items: {
        type: 'integer',
      },
    },
    is_homeroom: {
      type: 'integer',
    },
    original_rubric: 'integer',
    powered_by: 'string',
    copyright: 'string',
    processing: 'object',
    questions: 'array',
    is_global_survey: 'integer',
    global_survey_application: 'array',

    // event
    recurring_rule: 'string',
    counter: {
      type: 'object',
      properties: {
        contestants: 'integer',
        students: 'integer',
        sessions: 'integer',
        passed: 'integer',
        failed: 'integer',
      },
    },

    //pdf
    pdf_default_rotate_deg: 'integer',
    //video
    cannot_continue_learning_if_answer_question_incorrectly: 'integer',
    invalid_questions: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          iid: 'string',
          action: 'string',
        },
      },
    },

    order_status: 'string',
    payment_type: 'string',
    total_amount: 'float',
    drm_vid: 'string',
    reduced_price: 'string',
    count_learner: 'string',
    count_video: 'string',
    check_answer: 'integer',
    card_number: 'integer',
    enrollment_plans: 'array',
    teacher_replied: 'string',
    role_play_teacher: 'string',
    role_play_content: 'array',
    enrolmentplan_categories: 'array',
    is_trial: 'integer',
    is_trial_course: 'integer',
    display_type: 'string',
    learning_path_time: 'number',
  },
  required: ['id', 'iid', 'ntype'],
};
